import { EditableLocationSettings } from "../types/EditableLocationSettings";
import { scaffoldEdit } from "../../../common/scaffolding/reducers/scaffoldEdit";

export enum TypeKeys {
    FETCH_BEGIN = "SETTINGS/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "SETTINGS/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "SETTINGS/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "SETTINGS/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "SETTINGS/SAVE__EDITABLE_SUCCESS",
    SAVE_FAILURE = "SETTINGS/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<EditableLocationSettings, {}, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };
